

























































import {Component, Vue, Prop} from "vue-property-decorator";

import {
    getUserProfile
} from "@/api/user/user";

@Component({
})
export default class Profile extends Vue {
    @Prop() private userProfile!: object;

    private created() {
        var data = (this.userProfile as any)
        if (data.work_time_slot) {
            data.slot = ''
            data.work_time_slot.forEach((item, index) => {
                data.slot = data.slot + "," + item
            })
            data.slot = data.slot.toString().substring(1, data.slot.toString().length)
        }
        if (data.other_platform) {
            data.platform = ''
            data.other_platform.forEach((item, index) => {
                data.platform = data.platform + "," + item
            })
            data.platform = data.platform.toString().substring(1, data.platform.toString().length)
        }

        this.userProfile = data
    }
}
